module.exports = {
          srcSet: __webpack_public_path__ + "381e97cc.jpg"+" 700w"+","+__webpack_public_path__ + "08469dba.jpg"+" 1400w"+","+__webpack_public_path__ + "e37e0d5b.jpg"+" 2100w"+","+__webpack_public_path__ + "109ec8a1.jpg"+" 2592w",
          images:[ {path: __webpack_public_path__ + "381e97cc.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "08469dba.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "e37e0d5b.jpg",width: 2100,height: 1575},{path: __webpack_public_path__ + "109ec8a1.jpg",width: 2592,height: 1944}],
          src: __webpack_public_path__ + "381e97cc.jpg",
          toString:function(){return __webpack_public_path__ + "381e97cc.jpg"},
          
          width: 700,
          height: 525
        }